// @flow
import React from 'react'
import styled from 'styled-components'

const StyledAlert = styled.svg`
  margin-right: 10px;
  min-width: 15px;
  margin-top: 3px;
`

const Alert = () => {
  return (
    <StyledAlert height="15px" viewBox="0 0 15 15" width="15px" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <path d="m-1-1h16v16h-16z" />
        <g stroke="#6e7b8c">
          <circle cx="7.5" cy="7.5" r="7" strokeLinecap="square" />
          <circle cx="7.5" cy="4" r="1" />
          <path d="m7.5 11.5v-4" strokeLinecap="square" />
        </g>
      </g>
    </StyledAlert>
  )
}

export default Alert



// WEBPACK FOOTER //
// ./src/components/Icons/Alert.js